import script from "./PageTransition.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTransition.vue?vue&type=script&setup=true&lang=js"

import "./PageTransition.vue?vue&type=style&index=0&id=dbee289c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbee289c"]])

export default __exports__